export enum ActionStatus {
  InProgress = 1,
  Completed = 2,
  Overdue = 3,
  Cancelled = 4,
}
